<template>
  <div>
    <base-header
      type="gradient-success"
      class="pb-6 pb-8 pt-5 pt-md-8 header_gradiant"
    />

    <div class="container-fluid mt--7">
      <div class="card shadow p-4">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/admin/tipos-oleos">Tipos de Óleo</router-link>
            </li>
            <li class="breadcrumb-item active">Controle de Estoque</li>
          </ol>
        </nav>

        <div v-if="state.is_loading" class="text-center p-5">Carregando...</div>

        <template v-else-if="state.oleo">
          <div class="estoque-cabecalho">
            <div>
              <h2>Estoque — {{ state.oleo.nome }}</h2>
              <p class="saldo-atual">
                Saldo atual:
                <strong>{{ state.oleo.estoque }} unidade(s)</strong>
              </p>
            </div>
            <router-link to="/admin/tipos-oleos" class="btn_voltar">Voltar</router-link>
          </div>

          <div class="movimentacao-card">
            <h3>Nova movimentação</h3>
            <div class="row align-items-end">
              <div class="col-md-3">
                <label>Movimentação</label>
                <select v-model="state.tipo" class="form-select">
                  <option value="ENTRADA">Entrada</option>
                  <option value="SAIDA_MANUAL">Baixa manual</option>
                </select>
              </div>
              <div class="col-md-2">
                <label>Quantidade</label>
                <input
                  v-model.number="state.quantidade"
                  type="number"
                  min="1"
                  step="1"
                  class="form-control"
                />
              </div>
              <template v-if="state.tipo === 'ENTRADA'">
                <div class="col-md-4">
                  <label>Lote</label>
                  <input
                    v-model.trim="state.lote"
                    type="text"
                    maxlength="60"
                    class="form-control"
                    placeholder="Identificação do lote"
                  />
                </div>
                <div class="col-md-3">
                  <label>Data de manipulação</label>
                  <input
                    v-model="state.data_manipulacao"
                    type="date"
                    :max="hoje"
                    class="form-control"
                  />
                </div>
              </template>
              <div v-else class="col-md-7">
                <label>Lote a baixar</label>
                <select v-model="state.lote_id" class="form-select">
                  <option value="">Mais antigo primeiro (FEFO)</option>
                  <option v-for="lote in lotesDisponiveis" :key="lote.id" :value="lote.id">
                    {{ rotuloLote(lote) }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row align-items-end mt-3">
              <div class="col-md-10">
                <label>Observação</label>
                <input
                  v-model.trim="state.observacao"
                  type="text"
                  maxlength="500"
                  class="form-control"
                  placeholder="Motivo ou referência da movimentação"
                />
              </div>
              <div class="col-md-2">
                <button
                  type="button"
                  class="btn_confirmar"
                  :disabled="state.is_saving"
                  @click="salvarMovimento"
                >
                  {{ state.is_saving ? "Salvando..." : "Confirmar" }}
                </button>
              </div>
            </div>
          </div>

          <h3 class="mt-4">Lotes em estoque</h3>
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Lote</th>
                  <th>Data de manipulação</th>
                  <th>Total recebido</th>
                  <th>Saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="lote in state.lotes"
                  :key="lote.id"
                  :class="{ lote_zerado: Number(lote.saldo) === 0 }"
                >
                  <td>{{ lote.lote }}</td>
                  <td>{{ formatarDataSimples(lote.data_manipulacao) }}</td>
                  <td>{{ lote.quantidade_inicial }}</td>
                  <td>{{ lote.saldo }}</td>
                </tr>
                <tr v-if="state.lotes.length === 0">
                  <td colspan="4" class="text-center">Nenhum lote cadastrado.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 class="mt-4">Histórico de movimentações</h3>
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Tipo</th>
                  <th>Quantidade</th>
                  <th>Lote</th>
                  <th>Data manipulação</th>
                  <th>Saldo anterior</th>
                  <th>Saldo posterior</th>
                  <th>Responsável</th>
                  <th>Observação</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in state.historico"
                  :key="item.id"
                  :class="{ movimento_cancelado: item.cancelado_em }"
                >
                  <td>{{ formatarData(item.created_at) }}</td>
                  <td>{{ formatarTipo(item.tipo) }}</td>
                  <td>{{ item.quantidade }}</td>
                  <td>{{ item.lote || "—" }}</td>
                  <td>{{ formatarDataSimples(item.data_manipulacao) }}</td>
                  <td>{{ item.saldo_anterior }}</td>
                  <td>{{ item.saldo_posterior }}</td>
                  <td>{{ item.usuario ? item.usuario.name : "Sistema" }}</td>
                  <td>
                    {{ item.observacao || "—" }}
                    <span v-if="item.cancelado_em" class="tag_cancelado">cancelada</span>
                  </td>
                  <td>
                    <button
                      v-if="item.cancelavel"
                      type="button"
                      class="btn_cancelar_mov"
                      :disabled="state.cancelando_id === item.id"
                      @click="cancelarMovimento(item)"
                    >
                      {{ state.cancelando_id === item.id ? "..." : "Cancelar" }}
                    </button>
                    <span v-else>—</span>
                  </td>
                </tr>
                <tr v-if="state.historico.length === 0">
                  <td colspan="10" class="text-center">Nenhuma movimentação registrada.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStorage } from "vue3-storage";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import services from "../../services";

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const storage = useStorage();
    const token = storage.getStorageSync("token");
    const oleoId = Number(route.params.id);
    const hoje = dataHojeISO();

    const state = reactive({
      oleo: null,
      tipo: "ENTRADA",
      quantidade: 1,
      lote: "",
      data_manipulacao: "",
      lote_id: "",
      lotes: [],
      observacao: "",
      historico: [],
      is_loading: true,
      is_saving: false,
      cancelando_id: null,
    });

    // A lista ja chega em ordem FEFO do backend; o primeiro item e a
    // sugestao padrao de consumo.
    const lotesDisponiveis = computed(() =>
      state.lotes.filter((lote) => Number(lote.saldo) > 0)
    );

    onMounted(async () => {
      if (!Number.isInteger(oleoId) || oleoId <= 0) {
        toast.error("Tipo de óleo inválido.");
        await router.replace("/admin/tipos-oleos");
        return;
      }
      await carregarDados();
    });

    async function carregarDados() {
      Object.assign(state, { is_loading: true });
      try {
        const [estoque, movimentos, lotes] = await Promise.all([
          services.tipos_oleo.estoque({ id: oleoId, token }),
          services.tipos_oleo.movimentosEstoque({ id: oleoId, token }),
          services.tipos_oleo.lotesEstoque({ id: oleoId, token }),
        ]);
        Object.assign(state, {
          oleo: estoque.data,
          historico: Array.isArray(movimentos.data) ? movimentos.data : [],
          lotes: Array.isArray(lotes.data) ? lotes.data : [],
        });
      } catch (error) {
        toast.error(obterMensagemErro(error, "Não foi possível carregar o estoque."));
        await router.replace("/admin/tipos-oleos");
      } finally {
        Object.assign(state, { is_loading: false });
      }
    }

    async function salvarMovimento() {
      if (!Number.isInteger(state.quantidade) || state.quantidade <= 0) {
        toast.error("Informe uma quantidade inteira maior que zero.");
        return;
      }
      if (state.tipo === "SAIDA_MANUAL" && !state.observacao) {
        toast.error("Informe o motivo da baixa manual.");
        return;
      }
      if (state.tipo === "ENTRADA" && !state.lote) {
        toast.error("Informe o lote da entrada.");
        return;
      }
      if (state.tipo === "ENTRADA" && !state.data_manipulacao) {
        toast.error("Informe a data de manipulação da entrada.");
        return;
      }
      if (state.data_manipulacao && state.data_manipulacao > hoje) {
        toast.error("A data de manipulação não pode ser futura.");
        return;
      }
      if (state.tipo === "SAIDA_MANUAL" && lotesDisponiveis.value.length === 0) {
        toast.error("Não há lote com saldo para baixar.");
        return;
      }

      Object.assign(state, { is_saving: true });
      try {
        await services.tipos_oleo.movimentarEstoque({
          id: oleoId,
          token,
          movimento: montarMovimento(),
        });
        Object.assign(state, {
          quantidade: 1,
          lote: "",
          data_manipulacao: "",
          lote_id: "",
          observacao: "",
        });
        await carregarDados();
        toast.success("Estoque atualizado com sucesso.");
      } catch (error) {
        toast.error(obterMensagemErro(error, "Não foi possível movimentar o estoque."));
      } finally {
        Object.assign(state, { is_saving: false });
      }
    }

    // Cancelar nao apaga: o backend gera um movimento de compensacao e marca
    // o original como cancelado. Numa entrada isso retira as unidades do lote;
    // numa baixa manual, devolve.
    async function cancelarMovimento(item) {
      const entrada = item.tipo === "ENTRADA";
      const efeito = entrada
        ? "As " + item.quantidade + " unidade(s) serão retiradas do lote " + item.lote + "."
        : "As " + item.quantidade + " unidade(s) voltarão para o lote " + item.lote + ".";

      if (!confirm("Cancelar esta movimentação?\n\n" + efeito)) return;

      Object.assign(state, { cancelando_id: item.id });
      try {
        await services.tipos_oleo.cancelarMovimento({
          id: oleoId,
          movimento_id: item.id,
          token,
        });
        await carregarDados();
        toast.success("Movimentação cancelada.");
      } catch (error) {
        toast.error(
          obterMensagemErro(error, "Não foi possível cancelar a movimentação.")
        );
      } finally {
        Object.assign(state, { cancelando_id: null });
      }
    }

    // Na entrada o lote e digitado (cria ou soma ao existente); na baixa
    // manual ele e escolhido entre os que tem saldo, e vazio significa FEFO.
    function montarMovimento() {
      const movimento = {
        tipo: state.tipo,
        quantidade: state.quantidade,
        observacao: state.observacao || null,
      };

      if (state.tipo === "ENTRADA") {
        movimento.lote = state.lote;
        movimento.data_manipulacao = state.data_manipulacao;
      } else if (state.lote_id) {
        movimento.lote_id = state.lote_id;
      }

      return movimento;
    }

    function rotuloLote(lote) {
      const manipulacao = lote.data_manipulacao
        ? " — manipulado em " + formatarDataSimples(lote.data_manipulacao)
        : "";
      return lote.lote + " — " + lote.saldo + " em estoque" + manipulacao;
    }

    function formatarTipo(tipo) {
      const tipos = {
        ENTRADA: "Entrada",
        SAIDA_MANUAL: "Baixa manual",
        DISPENSA: "Dispensa",
        ESTORNO_DISPENSA: "Estorno de dispensa",
        ESTORNO_ENTRADA: "Cancelamento de entrada",
        ESTORNO_SAIDA_MANUAL: "Cancelamento de baixa",
      };
      return tipos[tipo] || tipo;
    }

    function formatarData(data) {
      return data ? new Date(data).toLocaleString("pt-BR") : "—";
    }

    // data_manipulacao chega como "AAAA-MM-DD"; converter com Date() deslocaria o dia
    // por causa do fuso, entao a formatacao e feita direto sobre a string.
    function formatarDataSimples(data) {
      if (!data) return "—";
      const partes = String(data).slice(0, 10).split("-");
      return partes.length === 3
        ? partes[2] + "/" + partes[1] + "/" + partes[0]
        : data;
    }

    function dataHojeISO() {
      const agora = new Date();
      const mes = String(agora.getMonth() + 1).padStart(2, "0");
      const dia = String(agora.getDate()).padStart(2, "0");
      return agora.getFullYear() + "-" + mes + "-" + dia;
    }

    function obterMensagemErro(error, mensagemPadrao) {
      const resposta = error && error.response && error.response.data;
      if (resposta && resposta.errors) {
        const mensagens = Object.values(resposta.errors).flat();
        if (mensagens.length) return mensagens[0];
      }
      return (resposta && resposta.message) || mensagemPadrao;
    }

    return {
      state,
      hoje,
      lotesDisponiveis,
      rotuloLote,
      salvarMovimento,
      cancelarMovimento,
      formatarTipo,
      formatarData,
      formatarDataSimples,
    };
  },
};
</script>

<style scoped>
.header_gradiant {
  background: linear-gradient(50deg, #007c7c 0%, #030c0c 100%, #007c7c) !important;
}

.estoque-cabecalho {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}

h2,
h3,
.saldo-atual,
label {
  color: #0a2423;
}

.saldo-atual {
  font-size: 14pt;
}

.movimentacao-card {
  background: #f7fbfb;
  border: 2px solid #0a2423;
  border-radius: 8px;
  padding: 20px;
}

.btn_confirmar,
.btn_voltar {
  background: #16524e;
  border: 2px solid #0a2423;
  border-radius: 5px;
  color: #fff;
  display: inline-block;
  min-height: 42px;
  padding: 8px 14px;
  text-align: center;
  width: 100%;
}

.btn_voltar {
  width: auto;
}

.btn_confirmar:disabled {
  cursor: wait;
  opacity: 0.65;
}

thead {
  background: #014a4a;
}

.lote_zerado {
  color: #8a8a8a;
}

.movimento_cancelado {
  color: #8a8a8a;
  text-decoration: line-through;
}

.tag_cancelado {
  background: #8a8a8a;
  border-radius: 3px;
  color: #fff;
  font-size: 8pt;
  padding: 1px 6px;
  text-decoration: none;
  vertical-align: middle;
}

.btn_cancelar_mov {
  background: #fff;
  border: 1px solid #a33;
  border-radius: 4px;
  color: #a33;
  font-size: 9pt;
  padding: 3px 10px;
}

.btn_cancelar_mov:disabled {
  cursor: wait;
  opacity: 0.6;
}

thead th {
  color: #fff;
}

@media (max-width: 767px) {
  .estoque-cabecalho {
    gap: 12px;
  }

  .movimentacao-card [class*="col-md-"] {
    margin-bottom: 15px;
  }
}
</style>
